module.exports = __webpack_public_path__ + "static/media/logo.9ba88b3f.svg";